export const placements = {
  mobileMainPanel: {
    value: 'mobileMainPanel',
    name: 'Aplikacja - panel główny'
  },
  mobileSecondaryPanel: {
    value: 'mobileSecondaryPanel',
    name: 'Aplikacja - panel dodatkowy'
  }
  // Na ten moment brakuje wsparcia dla poniższych opcji w user portal.
  // webMainPanel: { value: 'webMainPanel', name: 'WWW - panel główny' },
  // webSecondaryPanel: {
  //   value: 'webSecondaryPanel',
  //   name: 'WWW - panel dodatkowy'
  // }
}

export const statuses = {
  draft: { value: 'draft', name: 'Wersja robocza' },
  published: { value: 'published', name: 'Opublikowana' }
}
